import React from "react";
import R14, { View, Text } from "../core";
export default R14.connect(
  class TodoScreen extends React.Component {
    constructor(props) {
      super(props);
    }
    render() {
      return (
        <View>
          <Text>TODO</Text>
        </View>
      );
    }
  }
);
